module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "page-header-style"
  }, [_c('ul', {
    staticClass: "nav nav-pills"
  }, [_vm._m(0), _vm._v(" "), _c('li', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'pharmacy-carehome-user-edit',
        params: {
          carehomeid: _vm.çarehomeId
        }
      }
    }
  }, [_vm._v("\n                    Add User\n                ")])], 1)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "duration": 500
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.controller.isLoading),
      expression: "controller.isLoading"
    }],
    staticClass: "row",
    staticStyle: {
      "width": "100%",
      "position": "absolute",
      "text-align": "center",
      "vertical-align": "central"
    }
  }, [_c('br'), _c('br'), _c('br'), _vm._v(" "), _c('i', {
    staticClass: "fa fa-refresh fa-spin fa-2x fa-fw"
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Loading...")])])]), _vm._v(" "), _c('datatable', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.controller.isLoading),
      expression: "!controller.isLoading"
    }],
    attrs: {
      "columns": _vm.columns,
      "source": _vm.getUsers
    },
    on: {
      "selected": _vm.recordSelected
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "disabled"
  }, [_c('h4', {
    staticClass: "text-primary",
    staticStyle: {
      "margin-left": "15px",
      "margin": "10px"
    }
  }, [_c('b', [_vm._v("Carehome Users")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-fff6c9f2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fff6c9f2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/pages/user-list/user-list.scp.html
// module id = 522
// module chunks = 0